import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'form-row',
  templateUrl: './form-row.component.html',
  styleUrls: ['./form-row.component.scss']
})
export class FormRowComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
